// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TRIANGLE_WIDTH = '24';
const TRIANGLE_HEIGHT = '24';
const SMALL_TRIANGLE_WIDTH = '12';
const SMALL_TRIANGLE_HEIGHT = '10';
const TRIANGLE_VIEWBOX = '0 0 24 24';
const SMALL_TRIANGLE_VIEWBOX = '0 0 24 20';

export function ArrowLeft() {
  return (
    <svg
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Arrow Left"
      role="img"
    >
      <title>Arrow Left</title>
      <path
        d="M13.0753 19.7635L12.2871 20.5597L4 12.2799L12.2871 4L13.0753 4.79618L6.16186 11.7169H20V12.8428H6.16186L13.0753 19.7635Z"
        fill="currentColor"
      />
    </svg>
  );
}

type ArrowRightProps = {
  className?: string;
};

export function ArrowRight({ className }: ArrowRightProps) {
  return (
    <svg
      className={className}
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Arrow Right"
      role="img"
    >
      <title>Arrow Right</title>
      <path
        d="M10.9247 19.7635L11.7129 20.5597L20 12.2799L11.7129 4L10.9247 4.79618L17.8381 11.7169H4V12.8428H17.8381L10.9247 19.7635Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArrowUp() {
  return (
    <svg
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Arrow Up"
    >
      <title>Arrow Up</title>
      <path
        d="M19.4837 13.0753L20.2799 12.2871L12 4L3.72014 12.2871L4.51632 13.0753L11.437 6.16186L11.437 20L12.563 20L12.563 6.16186L19.4837 13.0753Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArrowDown() {
  return (
    <svg
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Arrow Down"
      role="img"
    >
      <title>Arrow Down</title>
      <path
        d="M4.51631 10.9247L3.72013 11.7129L12 20L20.2799 11.7129L19.4837 10.9247L12.563 17.8381L12.563 4L11.437 4L11.437 17.8381L4.51631 10.9247Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TriangleLeft() {
  return (
    <svg
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Arrow Left"
    >
      <title>Arrow Left</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12L16 6L16 18L6 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TriangleRight() {
  return (
    <svg
      width={TRIANGLE_WIDTH}
      height={TRIANGLE_HEIGHT}
      viewBox={TRIANGLE_VIEWBOX}
      fill="none"
      role="img"
      aria-label="Arrow Right"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Arrow Right</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12L8 18L8 6L18 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

type TriangleUpProps = {
  small: boolean;
  className?: string;
  width?: number;
  height?: number;
};

export function TriangleUp({
  small = false,
  className,
  width: explicitWidth,
  height: explicitHeight,
}: TriangleUpProps) {
  const defaultWidth = small ? SMALL_TRIANGLE_WIDTH : TRIANGLE_WIDTH;
  const defaultHeight = small ? SMALL_TRIANGLE_HEIGHT : TRIANGLE_HEIGHT;

  return (
    <svg
      className={className}
      width={explicitWidth || defaultWidth}
      height={explicitHeight || defaultHeight}
      viewBox={small ? SMALL_TRIANGLE_VIEWBOX : TRIANGLE_VIEWBOX}
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Arrow Up"
    >
      <title>Arrow Up</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={small ? 'M12 0L24 20L0 20L12 0Z' : 'M12 6L18 16L6 16L12 6Z'}
        fill="currentColor"
      />
    </svg>
  );
}

type TriangleDownProps = {
  small: boolean;
  className?: string;
  width?: number;
  height?: number;
};

export function TriangleDown({
  small = false,
  className,
  width: explicitWidth,
  height: explicitHeight,
}: TriangleDownProps) {
  const defaultWidth = small ? SMALL_TRIANGLE_WIDTH : TRIANGLE_WIDTH;
  const defaultHeight = small ? SMALL_TRIANGLE_HEIGHT : TRIANGLE_HEIGHT;

  return (
    <svg
      className={className}
      width={explicitWidth || defaultWidth}
      height={explicitHeight || defaultHeight}
      viewBox={small ? SMALL_TRIANGLE_VIEWBOX : TRIANGLE_VIEWBOX}
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Arrow Down"
      role="img"
    >
      <title>Arrow Down</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={small ? 'M12 20L0 0L24 0L12 20Z' : 'M12 18L6 8L18 8L12 18Z'}
        fill="currentColor"
      />
    </svg>
  );
}
